<div [ngClass]="mentionClass"
  [stickyPopover]="popContent"
  [openDelay]="500"
  popoverClass="tolaria-player-popover"
  container="body"
  (click)="openPlayerDetails()">@{{ name }}
</div>
<ng-template #popContent>
  <app-player-popover [id]="id" [showControls]="showControls"></app-player-popover>
</ng-template>